import { Routes } from '@angular/router';
import { DataResolverService } from '@resolver/data-resolver/data-resolver.service';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage)
  },
  {
    path: 'home/financiero',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage)
  },
  {
    path: 'home/operativo',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage)
  },
  {
    path: 'dashboard/financiero',
    loadComponent: () => import('./pages/dashboards/dashboard-financiero/dashboard-financiero.page').then(m => m.DashboardFinancieroPage)
  },
  {
    path: 'dashboard/operativo',
    loadComponent: () => import('./pages/dashboards/dashboard-operativo/dashboard-operativo.page').then(m => m.DashboardOperativoPage)
  },
  {
    path: 'dashboard/amdf',
    loadComponent: () => import('./pages/dashboards/dashboard-amdf/dashboard-amdf.page').then(m => m.DashboardAMDFPage)
  },
  {
    path: 'dashboard/mazda',
    loadComponent: () => import('./pages/dashboards/dashboard-by-dealer/dashboard-mazda/dashboard-mazda.page').then(m => m.DashboardMazdaPage)
  },
  {
    path: 'dashboard/bmw',
    loadComponent: () => import('./pages/dashboards/dashboard-by-dealer/dashboard-bmw/dashboard-bmw.page').then(m => m.DashboardBMWPage)
  },
  {
    path: 'dashboard_bsc/cpv',
    loadComponent: () => import('./pages/dashboards/dashboard-bsc/bsc-cpv/bsc-cpv.page').then(m => m.BSCDashboardCPVPage)
  },
  {
    path: 'dashboard_bsc/csi',
    loadComponent: () => import('./pages/dashboards/dashboard-bsc/bsc-csi/bsc-csi.page').then(m => m.BSCDashboardCSIPage)
  },
  {
    path: 'dashboard_bsc/csid',
    loadComponent: () => import('./pages/dashboards/dashboard-bsc/bsc-csid/bsc-csid.page').then(m => m.BSCDashboardCSIDPage)
  },
  {
    path: 'dashboard_bsc/csix',
    loadComponent: () => import('./pages/dashboards/dashboard-bsc/bsc-csix/bsc-csix.page').then(m => m.BSCDashboardCSIXPage)
  },
  {
    path: 'dashboard_bsc/sunus',
    loadComponent: () => import('./pages/dashboards/dashboard-bsc/bsc-sunus/bsc-sunus.page').then(m => m.BSCDashboardSUNUSPage)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'login/logout/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'login/redirect/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'claims',
    loadComponent: () => import('./pages/claims/claims.page').then(m => m.ClaimsPage)
  },
  {
    path: 'config',
    loadComponent: () => import('./pages/config/config.page').then(m => m.ConfigPage)
  },
  {
    path: 'score',
    loadComponent: () => import('./pages/score/score.page').then(m => m.ScorePage)
  },
  {
    path: 'score/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/score/score.page').then(m => m.ScorePage)
  },
  {
    path: 'travel/list/vessel',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/vessel-travel-list/vessel-travel-list.page').then(m => m.VesselTravelListPage)
  },
  {
    path: 'travel/list/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/travel-list/travel-list.page').then(m => m.TravelListPage)
  },
  // Current tracking map
  /* {
    path: 'tracking',
    loadChildren: () => import('./pages/tracking-map/tracking-map.module').then(m => m.TrackingMapPageModule)
  }, */
  // Test Intelligent tracking map
  {
    path: 'tracking',
    
    loadComponent: () => import('./pages/Intelligent-tracking-map/intelligent-tracking-map.page').then(m => m.IntelligentTrackingMapPage)
  },
  {
    path: 'tracking/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/Intelligent-tracking-map/intelligent-tracking-map.page').then(m => m.IntelligentTrackingMapPage)
  },
  {
    path: 'travel/detail/vessel/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/vessel-travel-detail/vessel-travel-detail.page').then(m => m.VesselTravelDetailPage)
  },
  {
    path: 'travel/detail/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/travel-detail/travel-detail.page').then(m => m.TravelDetailPage)
  },
  {
    path: 'report/list/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/report-list/report-list.page').then(m => m.ReportListPage)
  },
  {
    path: 'report/menu',
    loadComponent: () => import('./pages/report-menu/report-menu.page').then(m => m.ReportMenuPage)
  },
  {
    path: 'report/viewer/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/report-viewer/report-viewer.page').then(m => m.ReportViewerPage)
  },
  {
    path: 'modal-faq',
    loadComponent: () => import('./pages/modal-faq/modal-faq.page').then(m => m.ModalFaqPage)
  },
  {
    path: 'vehicle/single',
    loadComponent: () => import('./pages/single-query-vin/single-query-vin.page').then(m => m.SingleQueryVinPage)
  },
  {
    path: 'vehicle/single/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/single-query-vin/single-query-vin.page').then(m => m.SingleQueryVinPage)
  },
  {
    path: 'vehicle/multiple',
    loadComponent: () => import('./pages/multiple-vin-consult/multiple-vin-consult.page').then(m => m.MultipleVinConsultPage)
  },
  {
    path: 'exchange',
    loadComponent: () => import('./pages/exchange/exchange.page').then(m => m.ExchangePage)
  },
  {
    path: 'exchange-form',
    loadComponent: () => import('./pages/exchange-form/exchange-form.page').then(m => m.ExchangeFormPage)
  },
  {
    path: 'exchange/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/vin-exchange/vin-exchange.page').then(m => m.VinExchangePage)
  },
  {
    path: 'shipment-request',
    loadComponent: () => import('./pages/shipment-request/shipment-request.page').then(m => m.ShipmentRequestPage)
  },
  {
    path: 'shipment-request/filter',
    loadComponent: () => import('./pages/shipment-request/shipment-request-filter/shipment-request-filter.page').then(m => m.ShipmentRequestFilterPage)
  },
  {
    path: 'shipment-request/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/shipment-request/shipment-request.page').then(m => m.ShipmentRequestPage)
  },
  {
    path: 'equipment',
    loadComponent: () => import('./pages/consulta-de-tractor/consulta-de-tractor.page').then(m => m.ConsultaDeTractorPage)
  },
  {
    path: 'equipment/site',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/matriz-estatus-equipo/matriz-estatus-equipo.page').then(m => m.MatrizEstatusEquipoPage),
      },
      {
        path: ':id',
        resolve: { special: DataResolverService },
        loadComponent: () => import('./components/matriz-estatus-detail/matriz-estatus-detail.component').then(m => m.MatrizEstatusDetail),
      },
    ]
  },
  {
    path: 'equipment/schedule',
    loadComponent: () => import('./pages/programacion-carga/programacion-carga.page').then(m => m.ProgramacionCargaPage)
  },
  {
    path: 'equipment/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/consulta-de-tractor/consulta-de-tractor.page').then(m => m.ConsultaDeTractorPage)
  },
  {
    path: 'equipment/schedule/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/programacion-carga/programacion-carga.page').then(m => m.ProgramacionCargaPage)
  },
  {
    path: 'investor-relations',
    loadComponent: () => import('./pages/investor-relations/investor-relations.page').then(m => m.InvestorRelationsPage)
  },
  {
    path: 'consulta/by_site_mexico',
    loadComponent: () => import('./pages/consult-by-site-mexico/consult-by-site-mexico.page').then(m => m.ConsultBySiteMexicoPage)
  },
  {
    path: 'consulta/by_site_mexico/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/consult-by-site-mexico/consult-by-site-mexico.page').then(m => m.ConsultBySiteMexicoPage)
  },
  {
    path: 'alerts',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/alertas/alertas.page').then(m => m.AlertasPage),
      },
      {
        path: ':id',
        resolve: { special: DataResolverService },
        loadComponent: () => import('./components/alertas-detail/alertas-detail.component').then(m => m.AlertasDetail),
      },
    ]
  },
  {
    path: 'yards/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/patios/patios.page').then(m => m.PatiosPage)
  },
  {
    path: 'vehicle/list/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/multiple-vin-list/multiple-vin-list.page').then(m => m.MultipleVinListPage)
  },
  {
    path: 'assets-manager',
    loadComponent: () => import('./pages/assets-manager/assets-manager.page').then(m => m.AssetsManagerPage)
  },
  /* {
    path: 'rate-trip',
    loadComponent: () => import('./pages/rate-trip/rate-trip.page').then(m => m.RateTripPage)
  }, */
  /* {
    path: 'rate-trip-detail/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/rate-trip-detail/rate-trip-detail.page').then(m => m.RateTripDetailPage)
  }, */
  /* {
    path: 'report-damage/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/report-damage/report-damage.page').then(m => m.ReportDamagePage)
  }, */
  /* {
    path: 'report-damage-vin/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/report-damage-vin/report-damage-vin.page').then(m => m.ReportDamageVinPage)
  }, */
  {
    path: 'quantum/fleet',
    loadComponent: () => import('./pages/iframe/iframe.page').then(m => m.IframePage)
  },
  {
    path: 'quantum/civar/:id',
    resolve: {
      special: DataResolverService
    },
    loadComponent: () => import('./pages/iframe/iframe.page').then(m => m.IframePage)
  },
  {
    path: 'permissions',
    loadComponent: () => import('./pages/permissions/permissions.page').then(m => m.PermissionsPage)
  },
  {
    path: 'admin-panel',
    loadComponent: () => import('./pages/admin-panel/admin-panel.page').then(m => m.AdminPanelPage)
  },
  // {
  //   path: 'multiple-vin-list',
  //   loadChildren: () => import('./pages/multiple-vin-list/multiple-vin-list.module').then(m => m.MultipleVinListPageModule)
  // }
];
